<template>
  <div>
    <b-form>
      <b-form-group
          :label="$t('administrator.edit.password')"
          label-for="password"
      >
        <b-form-input
            id="password"
            type="password"
            v-model="plainPassword"
            @input="$v.plainPassword.$model = $event"
            :state="!$v.plainPassword.$dirty ? null :(!$v.plainPassword.$error)"
            trim></b-form-input>
        <p v-if="$v.plainPassword.$dirty && !$v.plainPassword.required" class="mb-0 text-danger">
          {{ $t('administrator.errors.required') }}
        </p>
        <p v-if="$v.plainPassword.$dirty && !$v.plainPassword.passwordValidatorRegex" class="text-danger">
          {{ $t('administrator.errors.password-is-too-simple') }}
        </p>
      </b-form-group>

      <b-form-group
          :label="$t('administrator.edit.repeat-password')"
          label-for="repeated-password"
      >
        <b-form-input
            id="repeated-password"
            type="password"
            v-model="repeatedPassword"
            @input="$v.repeatedPassword.$model = $event"
            :state="!$v.repeatedPassword.$dirty ? null :(!$v.repeatedPassword.$error)"
            trim></b-form-input>
        <p v-if="$v.repeatedPassword.$dirty && !$v.repeatedPassword.required" class="mb-0 text-danger">
          {{ $t('administrator.errors.required') }}
        </p>
        <p v-if="$v.repeatedPassword.$dirty && !$v.repeatedPassword.passwordValidatorRegex" class="mb-0 text-danger">
          {{ $t('administrator.errors.password-is-too-simple') }}
        </p>
        <p v-if="$v.repeatedPassword.$dirty && !$v.repeatedPassword.sameAsPassword" class="text-danger">
          {{ $t('administrator.errors.repeated-password') }}
        </p>
      </b-form-group>
    </b-form>
    <div v-if="!isCreateAdministratorPage || administratorData" class="d-flex justify-content-end">
      <router-link :to="{ name: 'administrator' }">
        <button type="button" class="btn btn-secondary mt-4 pl-5 pr-5 mr-1">{{ $t('administrator.details.btn.cancel') }}</button>
      </router-link>
      <button type="button" @click="saveAdministratorPassword" class="btn btn-success mt-4 pl-5 pr-5">{{ $t('administrator.details.btn.save') }}</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {required, minLength, sameAs, helpers} from 'vuelidate/lib/validators';
import alertify from "alertifyjs";

const passwordValidatorRegex = helpers.regex('passwordValidatorRegex', /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/);

export default {
  data() {
    return {
      errors: {
        required: 'This field is required!',
        passwordIsTooSimple: 'Password is too simple'
      }
    }
  },
  validations: {
    plainPassword: {
      required,
      minLength: minLength(1),
      passwordValidatorRegex
    },
    repeatedPassword: {
      required,
      minLength: minLength(1),
      passwordValidatorRegex,
      sameAsPassword: sameAs('plainPassword')
    }
  },
  beforeDestroy() {
    this.resetPasswordInputs();
  },
  computed: {
    ...mapState({
      administratorData: state => state.administrator.administratorDetails,
      isCreateAdministratorPage: state => state.administrator.isCreateAdministratorPage
    }),
    plainPassword: {
      get() {
        return this.$store.state.administrator.administratorPasswordForm.plainPassword;
      },
      set(value) {
        this.$store.commit('administrator/setFormPlainPassword', value)
      }
    },
    repeatedPassword: {
      get() {
        return this.$store.state.administrator.administratorPasswordForm.repeatedPassword;
      },
      set(value) {
        this.$store.commit('administrator/setFormRepeatedPassword', value)
      }
    }
  },
  methods: {
    saveAdministratorPassword() {
      if(!this.$v.$invalid) {
        const data = {
          plainPassword: this.plainPassword
        }
        this.$store.dispatch('administrator/setAdministratorPassword', data).then(() => {
          this.resetPasswordInputs();
          this.$store.dispatch('administrator/getAdministratorDetails', this.administratorData.id.uuid);
          alertify.success('Success');
          this.$v.$reset();
        });
      } else {
        this.$v.$touch();
      }
    },
    resetPasswordInputs() {
      this.$store.commit('administrator/resetAdministratorPasswordForm');
    },
  }
}
</script>
